import React from 'react'
import {
  TextField,
  TextFieldProps,
  Typography,
  Stack,
  useTheme,
  styled,
  InputAdornment,
} from '@mui/material'
import { useFormEditable } from '../../../providers'
import { Percent } from '@mui/icons-material'

// TODO: check why adding error prop, fires ts-error
// NOTE: try to avaoid errorMsg and user error string for both
type InputProps = {
  readonly?: boolean
  errorMsg?: string
} & TextFieldProps

const StyledTextField = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: '4px',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: theme.palette.grey[300],
    },
    '&:hover fieldset': {
      borderColor: theme.palette.grey[400],
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.grey[400],
      borderWidth: 1,
    },
    '& .Mui-disabled': {
      WebkitTextFillColor: 'black',
      backgroundColor: 'whitesmoke',
    },
  },
}))

export const Input = React.forwardRef<HTMLDivElement, InputProps>(
  ({ readonly, errorMsg, disabled, ...props }, ref) => {
    const theme = useTheme()
    const { isEditable } = useFormEditable()

    return (
      <Stack>
        <StyledTextField
          variant="outlined"
          {...props}
          ref={ref}
          disabled={readonly || !isEditable || disabled}
          slotProps={{
            input: {
              readOnly: readonly || !isEditable,
            },
          }}
        />
        {errorMsg && (
          <Typography fontSize="14px" color={theme?.palette?.error?.main}>
            {errorMsg}
          </Typography>
        )}
      </Stack>
    )
  }
)
